<template>
    <div class="area-logada-filtro-ativos" id="area-logada-filtro-ativos">
        <div class="mobile-filter-list d-xl-none" v-if="hasfilters">
            <span >Filtros:</span>
            <div  class="area-logada-filtro-ativos-list">
                <div
                    v-for="(filtro, idx) in Object.entries(activeFilters)"
                    :id="filtro[0]"
                    @click="removeFilter"
                    :key="idx"
                    class="area-logada-filtro-ativo-item"
                    >
                    {{ filtro[1] }}
                </div>
            </div>
        </div>
        <h2>Resultado da busca</h2>
        <span class="d-none d-xl-block">Filtros:</span>
        <div  class="area-logada-filtro-ativos-list d-none d-xl-flex">
            <div
                v-for="(filtro, idx) in Object.entries(activeFilters)"
                v-if="hasfilters"
                :id="filtro[0]"
                :key="idx"
                @click="removeFilter"
                class="area-logada-filtro-ativo-item"
                >
                {{ filtro[1] }}
            </div>
        </div>
    </div>
</template>
<script>

    export default {    
        props:{
            filtros: { type: [Array, Object] },
            page: String,
        },
        components: {
        },
        data() {
            return {
                filterList:{
                    'nm_devedor': (['Certidao'].includes(this.page) ? 'Nome do pesquisado' : 'Nome do devedor'),
                    'nm_nr_identificacao_devedor': (['Certidao'].includes(this.page) ? 'Documento do pesquisado' : 'Documento do devedor'),
                    'ocorrencia': 'Ocorrência',
                    'nm_nr_titulo': 'Nº Título',
                    'nm_nosso_numero': 'Nosso número',
                    'dt_cadastro': !(['aprovadas','Certidao','Cancelamento'].includes(this.page)) ? 'Data solicitação início' : 
                                (['Certidao','Cancelamento'].includes(this.page))? 'Data inicial' : 'Data solicitação',
                    'dt_vencimento': 'Data vencimento',
                    'vl_titulo': 'Valor do título',
                    'vl_saldo': (['Cancelamento'].includes(this.page)) ? 'Valor protestado' : 'Valor a protestar',
                    'nomeCobrador': 'Nome do cobrador',
                    'docCobrador': 'Documento do cobrador',
                    'status': 'Status',
                    'nrPedido': 'Número do pedido',
                    'dtVencimento': (['Certidao','Cancelamento'].includes(this.page))? 'Data final' : 'Data solicitação fim',
                },
                activeFilters:{}
            }
        },
        methods: {
            setFilters(){
                let filters = [];
                    Object.keys(this.filtros).forEach(filterKey => {
                        // filters.push(this.filterList[filterKey]);
                        filters[filterKey] = this.filterList[filterKey];
                    });
                    this.activeFilters = filters;
            },
            removeFilter(event){
                let removedFilter = event.target.id;
                delete this.activeFilters[removedFilter];
                event.target.remove();
                this.$emit('removeFilter', removedFilter);
            },
            limparFiltro(){
                this.activeFilters = {};
                let elements = document.querySelectorAll('.area-logada-filtro-ativo-item');
                elements.forEach(element => {
                    element.remove();
                });
            }
        },
        computed:{
            hasfilters:{
                get(){
                    return Object.keys(this.filtros).length > 0
                }
            },

        },
        mounted() {
            this.setFilters();
            this.$emit('setHeight',Number(document.getElementById('area-logada-filtro-ativos').offsetHeight));
        },
        
    }
</script>
<style>
.area-logada-filtro-ativos{display:flex; width: 100%;height:106px;padding-top: 20px;padding-bottom: 25px;align-items: center;justify-content: space-between;}
    .area-logada-filtro-ativos h2{text-align: left;font: normal normal 200 20px/27px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--secondary-color);margin-bottom: 0;flex: 0 1 auto;min-width: 176px;margin-right: 69px;}
    .area-logada-filtro-ativos span{text-align: left;font: normal normal 200 16px/17px 'Kanit', sans-serif; letter-spacing: -1%;color: var(--secondary-color);height: fit-content;margin-right: 12px;}
 
    .area-logada-filtro-ativos button.btn-export-xlsx{border: 3px solid #1ACEB5;background: #1ACEB5 0% 0% no-repeat padding-box;border-radius: 5px;padding:9px 10px;display:flex;align-items: center;justify-content: center;text-align: center;font: normal normal bold 15px/15px 'Kanit', sans-serif;letter-spacing: 0px;color: #FFFFFF;min-width: 176px;margin-left: 12px;}
        .area-logada-filtro-ativos button.btn-export-xlsx:hover{background: #ffffff 0% 0% no-repeat padding-box;color: #1ACEB5;}
    .area-logada-filtro-ativos button.btn-export-xlsx svg{width: 20px;height: 20px;margin-right: 6px;}
        .area-logada-filtro-ativos button.btn-export-xlsx svg path{fill:#ffffff;}
            .area-logada-filtro-ativos button.btn-export-xlsx:hover svg path{fill:#1ACEB5;}
   
    .area-logada-filtro-ativos .area-logada-filtro-ativos-list {flex: 1 1 auto;display:flex;height: fit-content;gap:13px;align-items: center;margin-bottom: -2px;flex-wrap: wrap;}
        .area-logada-filtro-ativos .area-logada-filtro-ativos-list .area-logada-filtro-ativo-item{display:flex;justify-content: center;align-items: center;background: #FFFFFF 0% 0% no-repeat padding-box;border: 1px solid #A8A8A8;border-radius: 5px;font: normal normal normal 15px/14px 'Kanit', sans-serif; letter-spacing: 0px;color: #A8A8A8;padding:4.4px 9px;cursor:pointer;}
            .area-logada-filtro-ativos .area-logada-filtro-ativos-list .area-logada-filtro-ativo-item::before{content: 'X';width: 14px;height: 14px;color: #FFFFFF;background: #4780F1 0% 0% no-repeat padding-box;border: 1px solid #FFFFFF;border-radius: 3px;text-align: left;font: normal normal normal 10px/14px 'Kanit', sans-serif; letter-spacing: 0px;color: #FFFFFF;display: flex;align-items: center;justify-content: center;margin-right: 6px;}
    
@media (max-width:1199px) {
    .area-logada-filtro-ativos{flex-wrap: wrap;height: fit-content;}
    .mobile-filter-list{display: flex;flex-flow:column;flex: 1 1 100%;max-width: 100%;height: fit-content;margin-bottom: 18px;padding-bottom: 21px;border-bottom: 1px solid #F1F1F1;}
    .mobile-filter-list span{margin-bottom: 13px;}
}

</style>
    